import { useTranslation } from 'react-i18next';

import { Row } from '../../';

type P = {
  title: string;
  subtitle: string;
};

const CardTab = ({ title, subtitle }: P) => {
  const { t } = useTranslation();

  return (
    <>
      <Row item={{ className: 'card-tab__title' }}>
        <p>{t(title)}</p>
      </Row>
      <Row item={{ className: 'card-tab__subtitle' }}>
        <p>{t(subtitle)}</p>
      </Row>
    </>
  );
};

export default CardTab;
